import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RevealLines } from "@/components/RevealText";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { BLOG_POSTS } from "@/data/blog";
import { ArrowUpRight } from "lucide-react";

const Blog = () => (
  <div data-testid="blog-page">
    <section className="pt-40 pb-16 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <Breadcrumbs items={[{ label: "Blog", to: "/blog" }]} />
        <div className="mt-10 flex items-center gap-4">
          <div className="h-px w-12 bg-edge" />
          <span className="text-[10px] tracking-[0.35em] text-edge uppercase font-bold">
            Journal
          </span>
        </div>
        <RevealLines
          as="h1"
          lines={[
            "Field notes on",
            <>
              insulation, <span className="text-edge">honestly</span>.
            </>,
          ]}
          className="mt-8 font-display font-black uppercase tracking-tighter text-[12vw] md:text-[9vw] lg:text-[6.5vw] leading-[0.9]"
        />
      </div>
    </section>

    <section className="py-16 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {BLOG_POSTS.map((post, i) => (
          <motion.article
            key={post.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.05 }}
            viewport={{ once: true }}
            data-testid={`blog-card-${post.slug}`}
          >
            <Link to={`/blog/${post.slug}`} className="group block">
              <div className="relative overflow-hidden aspect-[4/3] bg-ink-800 border border-white/10">
                <img
                  src={post.cover}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]"
                />
                <div className="absolute top-4 left-4 bg-ink-950/70 backdrop-blur-sm px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase text-edge">
                  {post.category}
                </div>
              </div>
              <div className="mt-6 flex items-center gap-4 text-[10px] tracking-widest uppercase text-slateink">
                <span>
                  {new Date(post.date).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
                <span className="w-1 h-1 bg-slateink rounded-full" />
                <span>{post.readTime}</span>
              </div>
              <h2 className="mt-4 font-display uppercase text-2xl font-black tracking-tight leading-tight group-hover:text-edge transition-colors">
                {post.title}
              </h2>
              <p className="mt-3 text-white/60 text-sm leading-relaxed">
                {post.excerpt}
              </p>
              <div className="mt-4 text-edge inline-flex items-center gap-1 text-xs uppercase tracking-widest">
                Read <ArrowUpRight className="w-3 h-3" />
              </div>
            </Link>
          </motion.article>
        ))}
      </div>
    </section>
  </div>
);

export default Blog;
